import { useEffect } from "react";
import {
  Svg,
  Circle,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  CircleGroup,
  LabContainer,
} from "./Overview.label.style";

import { useLocation } from "react-router-dom";
import { active_project } from "state/store.global";
import { useClick } from "./Overview.label.click";
import { _project } from "state/store.projects";
import { getFocus, useGet } from "state/jotai";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useLabelData } from "hooks/useLabelData";

dayjs.extend(customParseFormat);

export const MobileLabel = ({
  c,
  sc,
  d,
  l,
  rmode,
  labelsInfo,
  showLabel,
  setShowLabel,
  hoveredId,
}) => {

  const { pin, pid } = useGet(active_project);
  const options = getFocus(_project, "filteroptions");
  const allUnits = getFocus(_project, "units");

  const unitStatus = getFocus(_project, "unitStatuses")?.[pin]?.[pid] ?? [];
  
  const PID = labelsInfo?.PID;
  const PIN = labelsInfo?.PIN;

  const units = allUnits?.[PIN]?.[PID]?.Units ?? [];

  const {
    totalUnits,
    rMinSize,
    rMaxSize,
    noRmin,
    noRmax,
    finalMdate,
    saletype,
  } = useLabelData({ units, PID, PIN });
  
  const availableTranslation =
    unitStatus?.find((u) => u.ID === 10)?.Name ?? "";


  const roomSize = options?.[PIN]?.[PID]?.find(
    (p) => p?.Label === "Størrelse"
  );

  const buttonsLabel =
    getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const here = useLocation().pathname.split("/");
  const isOverview = here[here.length - 1] === "isometry";
  const click = useClick();

  if (isOverview && !rmode)
    return (
      <Pos
        c={c}
        style={{
          zIndex: hoveredId === labelsInfo?.URLSafe ? 10 : 5,
        }}
      >
        <Svg viewBox="0 0 100 100">
          <CircleGroup>
            <Circle clr={clr} cx={50} cy={50} r={15} />
            <Circle clr={clr} cx={50} cy={50} r={25} fillOpacity="0.5" />
            <Circle clr={clr} cx={50} cy={50} r={35} fillOpacity="0.3" />
          </CircleGroup>
        </Svg>

        <Outer d={d} l={l} xAxis={0} yAxis={-60}>
          <LabContainer d={d} l={l} clr={clr}>
            <Text2
              style={{
                padding: "4px 8px",
                fontSize: "0.85rem",
                lineHeight: 1.2,
              }}
            >
              Boliger til {saletype}
            </Text2>
          </LabContainer>
        </Outer>
      </Pos>
    );
};